import { ReceiptOrder } from '../../model/ReceiptOrder';
import { ReceiptOrderDtoIn } from '../../generated';
import { fromPhoneToGenerated } from './phoneNumber.parser';

export const fromReceiptOrderToGenerated = (data: ReceiptOrder): ReceiptOrderDtoIn => {
  return {
    clinic: data.clinic,
    note: data.note,
    email: data.user.email ?? '',
    phoneNumber: fromPhoneToGenerated(data.user.phone)
  };
};
